import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AgregarRecorridoPage } from './agregar-recorrido.page';

const routes: Routes = [
  {
    path: '',
    component: AgregarRecorridoPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AgregarRecorridoPage]
})
export class AgregarRecorridoPageModule {}
